import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// "Used on jobs" — appraisals whose roof diagram uses this template.
export const TemplateUsageList = ({ api, templateId }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!templateId) return;
    api.get(`/roof-templates/${templateId}/usage`).then(r => setData(r.data)).catch(() => setData({ count: 0, jobs: [] }));
  }, [api, templateId]);
  if (!data) return null;
  return (
    <div className="mt-2 border border-slate-200 rounded-md p-2 bg-slate-50" data-testid="rtpl-usage">
      <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1" data-testid="rtpl-usage-count">
        Used on jobs: {data.count}
      </div>
      {data.jobs.length === 0 ? <div className="text-[11px] text-slate-400">Not used on any job yet.</div> : (
        <ul className="space-y-0.5 max-h-40 overflow-auto">
          {data.jobs.map(j => (
            <li key={j.appraisal_id} className="text-[11px] text-slate-700" data-testid={`rtpl-usage-job-${j.appraisal_id}`}>
              <Link to={`/appraisals/${j.appraisal_id}`} className="text-[#316536] font-semibold hover:underline">{j.appraisal_no || 'Appraisal'}</Link>
              {j.client ? ` · ${j.client}` : ''}{j.address ? ` · ${j.address}` : ''} · {j.pin_count} pin{j.pin_count === 1 ? '' : 's'}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
